import React, { useState } from 'react';
import { strings } from '../../../localization';
import { ViewItemFolder } from './ViewItemFolder';

export const OrganizedViews = () => {
    const [activeFolder, setActiveFolder] = useState<string | null>(null);

    return (
        <>
            <ViewItemFolder
                caption={strings.View_Label_MySavedLists}
                activeFolder={activeFolder}
                setActiveFolder={setActiveFolder}
                listType="MY_SAVED"
                divider
            />
            <ViewItemFolder
                caption={strings.View_Label_MyDynamicLists}
                activeFolder={activeFolder}
                setActiveFolder={setActiveFolder}
                listType="MY_DYNAMIC"
            />
            <ViewItemFolder
                caption={strings.View_Label_SharedSavedList}
                activeFolder={activeFolder}
                setActiveFolder={setActiveFolder}
                listType="SHARED_SAVED"
            />
            <ViewItemFolder
                caption={strings.View_Label_SharedDynamicLists}
                activeFolder={activeFolder}
                setActiveFolder={setActiveFolder}
                listType="SHARED_DYNAMIC"
            />
        </>
    );
};
